<template>
  <div class="wrapper">
    <!-- 1.顶部标题 -->
    <el-header>
      <h3 class="title">
        <div class="block">
          <span>路由策略应用</span>
        </div>
      </h3>
    </el-header>
    <div class="main-content">
      <el-scrollbar class="scrollbar-wrap">
        <el-row class="text-center" style="margin-top: 30px">
          <el-col :span="12" :offset="5">
            <div class="webhfive-addbox-title">
              <i></i>
              <span>接入基本设置</span>
            </div>
            <div class="webhfive-addbox-box">
              <el-form ref="form1" label-width="250px" style="width:500px">
                <el-form-item class="text-left" label="渠道来源:" v-show="false">
                  <el-radio-group v-model="form1.source">
                    <el-radio label="1">iBot-PRO</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item class="text-left" v-for="(dim,index) in dimensions" :label="dim.name" :key="dim.id">
                  <el-select v-model="selectedDims[index]" :clearable="canClear(dim)" @change="changePlatform(dim)">
                    <el-option v-for="item in dim.tags" :key="item.id" :label="item.name" :value="item.tag">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="text-left" label="策略选择">
                  <el-select v-model="form1.selectedAcd">
                    <el-option v-for="item in acds" :key="item.id" :label="item.acdName" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="text-left" label="欢迎语">
                  <el-input type="textarea" maxlength="200" rows=4 style="width:100%" v-model="form1.welcomeMessage" placeholder="请输入欢迎语"></el-input>
                </el-form-item>
                <el-form-item class="text-left" label="头像">
                  <span>
                    <el-upload style="width:auto;float:left;" :before-upload="beforeImageUpload" :on-success="handleImageUpload" :show-file-list="false" :headers="headers" :with-credentials="true" :action="imageUploadAction">
                      <el-avatar shape="square" :size="80" :src="imageSrc" style="margin-right:10px;"></el-avatar>
                      <span class="link">
                        <svg class="icon icon-bianji" aria-hidden="true" style="font-size:16px;margin-right:3px;">
                          <use xlink:href="#iconxiangji" />
                        </svg>
                        <span>修改头像</span>
                      </span>
                    </el-upload>
                    <span class="link" style="margin-left:5px;line-height:14px;height:20px;white-space:nowrap;position:absolute;left:160px;top:70px;" @click="deleteImg(0)">
                      <svg class="icon icon-delete" aria-hidden="true" style="font-size:16px;margin-right:3px;">
                        <use xlink:href="#icontable-delete" />
                      </svg>
                      <span>删除头像</span>
                    </span>
                    <span style="float:left;margin-top:-10px;width:100%;color:#999;">大小：不超过1M，格式：png,jpg,gif</span>
                  </span>
                </el-form-item>
              </el-form>
            </div>

            <div class="webhfive-addbox-title">
              <i></i>
              <span>满意度评价配置</span>
            </div>
            <div class="webhfive-addbox-box">
              <el-form ref="form2" label-width="250px" style="width:700px">
                <el-form-item class="text-left" label="满意度评价方式" prop="evaluateMode">
                  <el-select v-model="form2.evaluateMode" placeholder="请输入">
                    <el-option v-for="mode in evaluateMode" :key="mode.value" :label="mode.label" :value="mode.value"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="text-left" label="满意度调查内容" prop="evaluateSearch">
                  <el-select v-model="form2.evaluateSearch" placeholder="请输入">
                    <el-option v-for="search in evaluateSearch" :key="search.value" :label="search.label" :value="search.value"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="text-left" label="自动触发方式" prop="autoTriggerMode">
                  <div>
                    <div v-for="(item, index) in form2.autoTriggerMode" :key="index">
                      <el-row>
                        <el-tooltip effect="light" :content="item.modeName+'触发'+(item.targetName + ' ' + (item.keyRule ? item.keyRule : (item.timeThreshold + '秒')))" placement="bottom">
                          <div class="pull-left">
                            方式{{index + 1}}
                            <span class="text-danger">
                              <el-input disabled style="width: 80%; margin-bottom: 5px;padding-right:10px;" :placeholder="item.modeName+'触发'+(item.targetName + ' ' + (item.keyRule ? item.keyRule : (item.timeThreshold + '秒')))">
                              </el-input>
                            </span>
                          </div>
                        </el-tooltip>
                        <el-button type="text" size="mini" @click="editAutoTrigger(index)">
                          <svg class="icon icon-bianji" aria-hidden="true">
                            <use xlink:href="#icontable-bianji" />
                          </svg>
                        </el-button>
                        <el-button type="text" size="mini" @click="deleteAutoTrigger(index)">
                          <svg class="icon icon-delete" aria-hidden="true">
                            <use xlink:href="#icontable-delete" />
                          </svg>
                        </el-button>
                      </el-row>
                    </div>
                    <el-row>
                      <el-col :span="5">
                        <el-button type="primary" @click="editAutoTrigger()">
                          <svg class="icon icon-bianji" aria-hidden="true" style="width:8px;">
                            <use xlink:href="#iconzengjia" />
                          </svg>
                        </el-button>
                      </el-col>
                      <el-col :span="2" :offset="2">
                        <el-button type="text">
                          <svg class="icon" aria-hidden="true">
                            <use xlink:href="#iconheadicon-help" />
                          </svg>
                        </el-button>
                      </el-col>
                      <el-col :span="15" style="line-height: 20px;">
                        <span>1.可添加多种触发方式</span>
                        <p />
                        <span>2.相同触发条件只能设置一次</span>
                      </el-col>
                    </el-row>
                  </div>
                  <el-dialog id="autoTriggerModify" :title="autoTriggerTitle" v-if="autoTriggerModify" :visible.sync="autoTriggerModify" width="400px" :close-on-click-modal="false">
                    <AutoTrigger :currTriggerSet="this.currTriggerSet" :currTriggerSetIndex="this.currTriggerSetIndex" @closeAutoTrigger="closeAutoTrigger"></AutoTrigger>
                  </el-dialog>
                </el-form-item>
                <el-form-item class="text-left" label="评价等级设置" prop="greeting">
                  <div class="pull-left">已设置 <span class="text-danger">{{ this.form2.evaluateGradeList.length }}</span> 个评价等级</div>
                  <a href="javaScript:;" class="link" @click="evaluteEditModify = true" style="margin-left:20px;">
                    <svg class="icon icon-bianji" aria-hidden="true" style="font-size:16px;margin-right:3px;">
                      <use xlink:href="#icontable-bianji" />
                    </svg>
                    <span>编辑修改</span>
                  </a>
                  <el-dialog id="evaluteEditModify" title="服务评价等级设置" v-if="evaluteEditModify" :visible.sync="evaluteEditModify" width="1000px" :close-on-click-modal="false" :show-close="false">
                    <EvaluateGrade ref="evaluateGradeRef" :evaluateGradeList="this.form2.evaluateGradeList" @closeEvaluateGradeList="closeEvaluateGradeList"></EvaluateGrade>
                  </el-dialog>
                </el-form-item>
                <el-form-item class="text-left" label="评价调查设置" prop="evaluateSet">
                  <el-select v-model="form2.evaluateSet.type" placeholder="请选择" style="width:140px;">
                    <el-option v-for="set in evaluateSetType" :key="set.value" :label="set.label" :value="set.value"></el-option>
                  </el-select>
                  <el-select multiple collapse-tags v-model='form2.evaluateSet.grades' style="max-width:178px;" v-if="form2.evaluateSet.type === 'auto'" placeholder="触发评价等级">
                    <el-option v-for='item in this.form2.evaluateGradeList' :key='item.rate' :label='item.rateName' :value='item.rate'></el-option>
                  </el-select>
                  <el-button type="primary" size="medium" @click="evaluteSetModify = true" v-if="form2.evaluateSet.type === 'fixed'">调查选项设置</el-button>
                  <el-dialog id="evaluteSetModify" title="调查选项设置" v-if="evaluteSetModify" :visible.sync="evaluteSetModify" width="650px" :close-on-click-modal="false" :show-close="false">
                    <FixedEvaluteSet ref="evaluateSetRef" :fixedEvaluteSets="this.form2.evaluateSet.fixedEvaluteSets" :evaluateGradeList="this.form2.evaluateGradeList" @closeFixedEvaluteSet="closeFixedEvaluteSet"></FixedEvaluteSet>
                  </el-dialog>
                </el-form-item>
              </el-form>
            </div>

            <div class="webhfive-addbox-title">
              <i class></i>
              <span>Web网站聊窗模式</span>
            </div>
            <div class="webhfive-addbox-box">
              <el-form ref="form3" :model="form3" label-width="250px" style="width:700px">
                <el-form-item class="text-left" label="模式选择">
                  <el-radio-group v-model="form3.dialogStyle" class="radio-border">
                    <el-radio :label="'default'" border style="width: 72px; height: 56px;">
                      <img src="@/assets/images/channel/web/default.png" title="仅聊窗" />
                    </el-radio>
                    <el-radio :label="'default_qr'" border style="width: 72px; height: 56px;">
                      <img src="@/assets/images/channel/web/default_qr.png" title="聊窗+推荐" />
                    </el-radio>
                    <el-radio :label="'default_recmd'" border style="width: 72px; height: 56px;">
                      <img src="@/assets/images/channel/web/default_recmd.png" title="聊窗+常见问题" />
                    </el-radio>
                    <el-radio :label="'default_recmd_qr'" border style="width: 72px; height: 56px;">
                      <img src="@/assets/images/channel/web/default_recmd_qr.png" title="聊窗+推荐+常见问题" />
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item class="text-left" label="常见问题配置" v-show="form3.dialogStyle === 'default_qr' || form3.dialogStyle === 'default_recmd_qr'">
                  <div class="pull-left">已设置 <span class="text-danger">{{ form3.commonQANum }}</span> 个常见问题</div>
                  <a href="javaScript:;" class="link" @click="commonQAModify = true" style="margin-left:20px;">
                    <svg class="icon icon-bianji" aria-hidden="true" style="font-size:16px;margin-right:3px;">
                      <use xlink:href="#icontable-bianji" />
                    </svg>
                    <span>编辑修改</span>
                  </a>
                  <el-dialog id="commonQAModify" title="常见问题配置" v-if="commonQAModify" :visible.sync="commonQAModify" width="1000px" :close-on-click-modal="false">
                    <CommonQA :channelId="this.cachePlatformAcdId" :tempCommonQAList="this.tempCommonQAList" @setCommonQANum="setCommonQANum"></CommonQA>
                  </el-dialog>
                </el-form-item>
                <el-form-item class="text-left" label="推荐栏1配置" v-show="form3.dialogStyle === 'default_recmd' || form3.dialogStyle === 'default_recmd_qr'">
                  <el-upload :headers="headers" :action="imageUploadAction" :show-file-list="false" :on-success="handleRecommendPic1Success" :before-upload="beforeUpload2" accept="image/*">
                    <img v-if="recommendBar1Url" :src="recommendBar1Url" class="avatarImgCls2" style="float: left;" />
                    <span>
                      <el-button size="small" type="primary" v-if="!recommendBar1Url">
                        <svg class="icon" aria-hidden="true">
                          <use xlink:href="#icontupian" />
                        </svg>
                        点击上传图片
                      </el-button>
                    </span>
                    <span slot="tip" class="link" v-if="recommendBar1Url" style="margin: 40px 0px 0 10px;line-height: 24px;height: 24px;display: inline-block;" @click="deleteImg(1)">
                      <svg class="icon icon-bianji" aria-hidden="true" style="font-size:16px;margin-right:3px;">
                        <use xlink:href="#icontable-delete" />
                      </svg>
                      <span>删除图片</span>
                    </span>
                    <div slot="tip" class="el-upload__tip">支持jpg/jpeg/png/gif格式，文件需小于2M</div>
                    <div slot="tip" style="padding-top:5px;width:96%;" v-if="recommendBar1Url"><span style="color:red;">* </span>文字<el-input v-model="form3.recommendBar1.note" placeholder="请输入图片描述" style="padding-left:5px;"></el-input>
                    </div>
                    <div slot="tip" style="padding-top:5px;width:96%;" v-if="recommendBar1Url"><span style="color:red;">* </span>链接<el-input v-model="form3.recommendBar1.link" placeholder="请输入跳转链接" style="padding-left:5px;"></el-input>
                    </div>
                  </el-upload>
                </el-form-item>
                <el-form-item class="text-left" label="推荐栏2配置" v-show="form3.dialogStyle === 'default_recmd' || form3.dialogStyle === 'default_recmd_qr'">
                  <el-upload :headers="headers" :action="imageUploadAction" :show-file-list="false" :on-success="handleRecommendPic2Success" :before-upload="beforeUpload2" accept="image/*">
                    <img v-if="recommendBar2Url" :src="recommendBar2Url" class="avatarImgCls2" style="float: left;" />
                    <el-button size="small" type="primary" v-if="!recommendBar2Url">
                      <svg class="icon" aria-hidden="true">
                        <use xlink:href="#icontupian" />
                      </svg>
                      点击上传图片
                    </el-button>
                    <span slot="tip" class="link" v-if="recommendBar2Url" style="margin: 40px 0px 0 10px;line-height: 24px;height: 24px;display: inline-block;" @click="deleteImg(2)">
                      <svg class="icon icon-bianji" aria-hidden="true" style="font-size:16px;margin-right:3px;">
                        <use xlink:href="#icontable-delete" />
                      </svg>
                      <span>删除图片</span>
                    </span>
                    <div slot="tip" class="el-upload__tip">支持jpg/jpeg/png/gif格式，文件需小于2M</div>
                    <div slot="tip" style="padding-top:5px;width:96%;" v-if="recommendBar2Url"><span style="color:red;">* </span>文字<el-input v-model="form3.recommendBar2.note" placeholder="请输入图片描述" style="padding-left:5px;"></el-input>
                    </div>
                    <div slot="tip" style="padding-top:5px;width:96%;" v-if="recommendBar2Url"><span style="color:red;">* </span>链接<el-input v-model="form3.recommendBar2.link" placeholder="请输入跳转链接" style="padding-left:5px;"></el-input>
                    </div>
                  </el-upload>
                </el-form-item>
                <el-form-item class="text-left" label="推荐栏3配置" v-show="form3.dialogStyle === 'default_recmd' || form3.dialogStyle === 'default_recmd_qr'">
                  <el-upload :headers="headers" :action="imageUploadAction" :show-file-list="false" :on-success="handleRecommendPic3Success" :before-upload="beforeUpload2" accept="image/*">
                    <img v-if="recommendBar3Url" :src="recommendBar3Url" class="avatarImgCls2" style="float: left;" />
                    <el-button size="small" type="primary" v-if="!recommendBar3Url">
                      <svg class="icon" aria-hidden="true">
                        <use xlink:href="#icontupian" />
                      </svg>
                      点击上传图片
                    </el-button>
                    <span slot="tip" class="link" v-if="recommendBar3Url" style="margin: 40px 0px 0 10px;line-height: 24px;height: 24px;display: inline-block;" @click="deleteImg(3)">
                      <svg class="icon icon-bianji" aria-hidden="true" style="font-size:16px;margin-right:3px;">
                        <use xlink:href="#icontable-delete" />
                      </svg>
                      <span>删除图片</span>
                    </span>
                    <div slot="tip" class="el-upload__tip">支持jpg/jpeg/png/gif格式，文件需小于2M</div>
                    <div slot="tip" style="padding-top:5px;width:96%;" v-if="recommendBar3Url"><span style="color:red;">* </span>文字<el-input v-model="form3.recommendBar3.note" placeholder="请输入图片描述" style="padding-left:5px;"></el-input>
                    </div>
                    <div slot="tip" style="padding-top:5px;width:96%;" v-if="recommendBar3Url"><span style="color:red;">* </span>链接<el-input v-model="form3.recommendBar3.link" placeholder="请输入跳转链接" style="padding-left:5px;"></el-input>
                    </div>
                  </el-upload>
                </el-form-item>
              </el-form>
            </div>
          </el-col>
        </el-row>
      </el-scrollbar>
      <el-row class="text-center system-stepbtn">
        <el-button @click="cancel" class="customer-mr20" size="medium">取 消</el-button>
        <el-button size="medium" @click="save" type="primary">保存</el-button>
      </el-row>
    </div>
  </div>
</template>

<script>
import FixedEvaluteSet from '@/views/components/webSet/FixedEvaluteSet'
import EvaluateGrade from '@/views/components/webSet/EvaluateGrade'
import AutoTrigger from '@/views/components/webSet/AutoTrigger'
import CommonQA from '@/views/components/webSet/CommonQA'
import { insertMutil, updateChannelId } from '@/api/channel/commonQA.js'
import { getDimensions, savePlatformAcd, getPlatformAcdById, getAcdByChannelIds } from '@/api/user'
export default {
  name: 'platformyAdd',
  components: { AutoTrigger, EvaluateGrade, FixedEvaluteSet, CommonQA },
  data() {
    return {
      // 接入基本设置
      form1: {
        source: '1',
        selectedAcd: '',
        welcomeMessage: '',
        avatar: ''
      },
      // 满意度评价配置
      form2: {
        evaluateMode: 'card',
        evaluateSearch: 'serviceAndProblem',
        autoTriggerMode: [],
        evaluateGradeList: [],
        evaluateSet: { type: 'close', grades: [], fixedEvaluteSets: [] }
      },
      // 满意度调查方式
      evaluateMode: [
        {
          value: 'card',
          label: '选项卡片'
        },
        {
          value: 'text',
          label: '文字交互'
        }
      ],
      // 满意度调查内容
      evaluateSearch: [
        {
          value: 'service',
          label: '仅服务满意度'
        },
        {
          value: 'serviceAndProblem',
          label: '服务满意度 + 问题解决情况'
        }
      ],
      evaluateSetType: [
        {
          value: 'close',
          label: '关闭评价调查'
        },
        {
          value: 'auto',
          label: '访客自定义输入'
        },
        {
          value: 'fixed',
          label: '固定选项选择'
        }
      ],
      evaluteEditModify: false,
      autoTriggerModify: false,
      evaluteSetModify: false,
      autoTriggerTitle: '',
      currTriggerSet: {},
      currTriggerSetIndex: 0,
      acds: [],
      dimensions: [],
      selectedDims: [],
      imageSrc: '',
      imageUploadAction: window.$envUtils('VUE_APP_BASE_URL') + window.$envUtils('VUE_APP_BP_SERVICE') + '/res/upload/file?fileType=6&isTemp=false&subPath=acdPic',
      imageDownloadAction: window.$envUtils('VUE_APP_BASE_URL') + window.$envUtils('VUE_APP_BP_SERVICE') + '/res/download',
      form3: {
        dialogStyle: 'default', // default/right_wrap/both_wrap/left_wrap
        commonQANum: 0,
        recommendBar1: {
          note: '',
          link: '',
          url: ''
        },
        recommendBar2: {
          note: '',
          link: '',
          url: ''
        },
        recommendBar3: {
          note: '',
          link: '',
          url: ''
        }
      },
      recommendBar1Url: '',
      recommendBar2Url: '',
      recommendBar3Url: '',
      commonQAModify: false,
      tempCommonQAList: []
    }
  },
  computed: {
    cachePlatformAcdId() {
      return this.$store.state.user.curPlatformAcdId
    },
    headers() {
      return {
        'X-TENANT-ID': localStorage.getItem('X-TENANT-ID')
      }
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    async initData() {
      await this._getDimensions()
      if (this.cachePlatformAcdId) {
        this._getPlatformAcdById()
      }
    },
    canClear(dim) {
      if (dim && dim.code !== 'platform') {
        return true
      }
      return false
    },
    cancel() {
      this.$store.commit('user/setPlatformApplyAcdPageIndex', { platformApplyAcdPageIndex: 1 })
    },
    _getDimensions() {
      return new Promise((resolve, reject) => {
        getDimensions({
          detail: false
        }).then(
          res => {
            if (res.code === 2000) {
              this.dimensions = res.data
              resolve()
            } else {
              this.$message.error(res.msg)
            }
          }
        )
      })
    },
    _getPlatformAcdById() {
      getPlatformAcdById({
        id: this.cachePlatformAcdId
      }).then(
        res => {
          if (res.code === 2000) {
            var data = res.data
            const dims = JSON.parse(data.dimension)
            for (var i = 0, len = this.dimensions.length; i < len; i++) {
              for (var key in this.dimensions[i]) {
                if (key === 'code') {
                  const v = this.getValueBySameKey(dims, this.dimensions[i][key])
                  if (v) {
                    this.selectedDims[i] = v
                  }
                }
              }
            }
            this.form1.source = data.sourceId
            this.form1.selectedAcd = data.acdId
            this.form1.welcomeMessage = data.welcomeMessage
            this.form1.avatar = data.avatar
            // 评价数据
            if (data.evaluateMode) {
              this.form2.evaluateMode = data.evaluateMode
              this.form2.evaluateSearch = data.evaluateSearch
              // this.form2.autoTriggerMode = data.autoTriggerMode && data.autoTriggerMode.length > 0 ? JSON.parse(data.autoTriggerMode) : []
              this.form2.autoTriggerMode = data.autoTriggerMode && data.autoTriggerMode.length > 0 ? data.autoTriggerMode : []
              // this.form2.evaluateGradeList = data.evaluateGradeList && data.evaluateGradeList.length > 0 ? JSON.parse(data.evaluateGradeList) : []
              this.form2.evaluateGradeList = data.evaluateGradeList && data.evaluateGradeList.length > 0 ? data.evaluateGradeList : []

              // var evaluateSet = data.evaluateSet && data.evaluateSet.length > 0 ? JSON.parse(data.evaluateSet) : { type: 'close', grades: [], fixedEvaluteSets: [] }
              var evaluateSet = data.evaluateSet ? data.evaluateSet : { type: 'close', grades: [], fixedEvaluteSets: [] }
              this.form2.evaluateSet.type = evaluateSet.type
              this.form2.evaluateSet.grades = evaluateSet.grades
              this.form2.evaluateSet.fixedEvaluteSets = evaluateSet.fixedEvaluteSets
            }
            // 网站QA和推荐数据
            const dialogStyleList = ['default', 'default_recmd', 'default_qr', 'default_recmd_qr']
            this.form3.dialogStyle = dialogStyleList.indexOf(data.dialogStyle) > -1 ? data.dialogStyle : 'default'
            this.form3.commonQANum = data.commonQANum ? data.commonQANum : 0
            // this.form3.recommendBar1 = data.recommendBar1 && data.recommendBar1.length > 0 ? JSON.parse(data.recommendBar1) : {}
            Object.assign(this.form3.recommendBar1, data.recommendBar1 ? data.recommendBar1 : { note: '', link: '', url: '' })
            if (this.form3.recommendBar1.url) {
              this.recommendBar1Url = this.imageDownloadAction + this.form3.recommendBar1.url
            }
            // this.form3.recommendBar2 = data.recommendBar2 && data.recommendBar2.length ? JSON.parse(data.recommendBar2) : {}
            Object.assign(this.form3.recommendBar2, data.recommendBar2 ? data.recommendBar2 : { note: '', link: '', url: '' })
            if (this.form3.recommendBar2.url) {
              this.recommendBar2Url = this.imageDownloadAction + this.form3.recommendBar2.url
            }
            // this.form3.recommendBar3 = data.recommendBar3 && data.recommendBar3.length ? JSON.parse(data.recommendBar3) : {}
            Object.assign(this.form3.recommendBar3, data.recommendBar3 ? data.recommendBar3 : { note: '', link: '', url: '' })
            if (this.form3.recommendBar3.url) {
              this.recommendBar3Url = this.imageDownloadAction + this.form3.recommendBar3.url
            }
            // 头像数据处理
            if (data.avatar) {
              this.imageSrc = this.imageDownloadAction + data.avatar
            } else {
              this.imageSrc = './home/images/robotAgent.jpg'
            }
            this._getAcdByChannelIds()
          } else {
            this.$message.error(res.msg)
          }
        }
      )
    },
    getValueBySameKey(data, skey) {
      for (var i = 0, len = data.length; i < len; i++) {
        for (var key in data[i]) {
          if (key === skey) {
            return data[i][key]
          }
        }
      }
      return null
    },
    save() {
      // 评价调查设置校验
      if (this.form2.evaluateSet.type === 'auto') {
        if (this.form2.evaluateSet.grades.length === 0) {
          this.$message.warning('访客自定义输入时，触发评价等级不能为空！')
          return
        }
        this.form2.evaluateSet.fixedEvaluteSets = []
      } else if (this.form2.evaluateSet.type === 'fixed') {
        if (this.form2.evaluateSet.fixedEvaluteSets.length === 0) {
          this.$message.warning('固定选项选择时，调查选项设置不能为空！')
          return
        }
        this.form2.evaluateSet.grades = []
      } else if (this.form2.evaluateSet.type === 'close') {
        this.form2.evaluateSet.grades = []
        this.form2.evaluateSet.fixedEvaluteSets = []
      }
      // 推荐栏校验
      if (this.form3.recommendBar1.url && this.form3.recommendBar1.url.trim()) {
        if (!this.form3.recommendBar1.note || !this.form3.recommendBar1.link) {
          this.$message.warning('推荐栏1配置中图片不为空时，文字和链接也不能为空！')
          return
        }
      } else {
        this.form3.recommendBar1 = {}
      }
      if (this.form3.recommendBar2.url && this.form3.recommendBar2.url.trim()) {
        if (!this.form3.recommendBar2.note || !this.form3.recommendBar2.link) {
          this.$message.warning('推荐栏2配置中图片不为空时，文字和链接也不能为空！')
          return
        }
      } else {
        this.form3.recommendBar2 = {}
      }
      if (this.form3.recommendBar3.url && this.form3.recommendBar3.url.trim()) {
        if (!this.form3.recommendBar3.note || !this.form3.recommendBar3.link) {
          this.$message.warning('推荐栏3配置中图片不为空时，文字和链接也不能为空！')
          return
        }
      } else {
        this.form3.recommendBar3 = {}
      }
      const dim = this.genDims()
      // 预处理表单参数
      const configs = {
        id: this.cachePlatformAcdId,
        sourceId: this.form1.source,
        acdId: this.form1.selectedAcd,
        welcomeMessage: this.form1.welcomeMessage,
        dimension: JSON.stringify(dim),
        avatar: this.form1.avatar,
        ...this.form2,
        ...this.form3
      }
      savePlatformAcd(configs).then(
        res => {
          if (res.code === 2000) {
            this.$message.success(res.msg)
            if (!configs.id) {
              this.insertMutil(res.data)
            }
            this.$store.commit('user/setPlatformApplyAcdPageIndex', { platformApplyAcdPageIndex: 1 })
          } else {
            this.$message.error(res.msg)
          }
        }
      )
    },
    changePlatform(dim) {
      if (dim.code === 'platform') {
        this._getAcdByChannelIds()
        this.form1.selectedAcd = ''
      }
    },
    _getAcdByChannelIds() {
      let channelIds = []
      const dim = this.genDims()
      for (var i = 0, len = dim.length; i < len; i++) {
        let b = false
        for (var key in dim[i]) {
          if (key === 'platform') {
            channelIds = [dim[i][key]]
            b = true
            break
          }
        }
        if (b) {
          break
        }
      }
      getAcdByChannelIds({
        channelIds: channelIds
      }).then(
        res => {
          if (res.code === 2000) {
            this.acds = res.data
          } else {
            this.$message.error(res.msg)
          }
        }
      )
    },
    genDims() {
      const dim = []
      this.dimensions.forEach((v, index) => {
        if (this.selectedDims[index]) {
          dim.push({ [v.code]: this.selectedDims[index] })
        }
      })
      return dim
    },
    // 图片上传检查
    beforeImageUpload(img) {
      const isValid = (img.type === 'image/png' || img.type === 'image/jpeg' || img.type === 'image/gif')
      const isLt2M = img.size / 1024 / 1024 < 1
      if (!isValid) {
        this.$message.error('上传头像图片只能是JPG或GIF或PNG格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过1MB!')
      }
      return isValid && isLt2M
    },

    // 图片上传加工处理
    handleImageUpload(res) {
      this.form1.avatar = res.url
      this.imageSrc = this.imageDownloadAction + res.url
    },
    deleteImg(_no) {
      if (_no === 0) {
        this.form1.avatar = null
        this.imageSrc = './home/images/robotAgent.jpg'
      } else if (_no === 1) {
        this.recommendBar1Url = ''
        this.form3.recommendBar1 = {}
      } else if (_no === 2) {
        this.recommendBar2Url = ''
        this.form3.recommendBar2 = {}
      } else if (_no === 3) {
        this.recommendBar3Url = ''
        this.form3.recommendBar3 = {}
      }
    },
    // 编辑满意度自动触发方式
    editAutoTrigger(index) {
      if (index !== undefined) {
        this.currTriggerSetIndex = index
        this.autoTriggerTitle = '自动触发方式' + (index + 1)
        this.currTriggerSet = this.form2.autoTriggerMode[index]
      } else {
        this.currTriggerSetIndex = this.form2.autoTriggerMode.length
        this.autoTriggerTitle = '自动触发方式' + (this.form2.autoTriggerMode.length + 1)
      }
      this.autoTriggerModify = true
    },
    // 删除满意度自动触发方式
    deleteAutoTrigger(index) {
      this.form2.autoTriggerMode.splice(index, 1)
    },
    // 关闭满意度自动触发方式弹框
    closeAutoTrigger(data) {
      if (data === null) {
        this.autoTriggerModify = false
      } else {
        const sameData = this.form2.autoTriggerMode.filter((item, index, arr) => item.mode === data.mode && item.target === data.target && index !== this.currTriggerSetIndex)
        if (sameData === null || sameData.length === 0) {
          this.form2.autoTriggerMode.splice(this.currTriggerSetIndex, 1, data)
          this.autoTriggerModify = false
        } else {
          this.$message.error('该组触发方式已存在！')
        }
      }
    },
    closeEvaluateGradeList(data) {
      if (data) {
        this.form2.evaluateGradeList = data
      }
      this.evaluteEditModify = false
    },
    closeFixedEvaluteSet(data) {
      if (data) {
        this.form2.evaluateSet.fixedEvaluteSets = data
      }
      this.evaluteSetModify = false
    },
    // 推荐栏1图片上传成功后的处理
    handleRecommendPic1Success(res, file) {
      this.recommendBar1Url = URL.createObjectURL(file.raw)
      this.form3.recommendBar1.url = res.url
      if (!this.form3.recommendBar1.note) {
        this.form3.recommendBar1.note = '推荐栏1'
      }
      if (!this.form3.recommendBar1.link) {
        this.form3.recommendBar1.link = 'https://www.xiaoi.com'
      }
    },
    // 推荐栏2图片上传成功后的处理
    handleRecommendPic2Success(res, file) {
      this.recommendBar2Url = URL.createObjectURL(file.raw)
      this.form3.recommendBar2.url = res.url
      if (!this.form3.recommendBar2.note) {
        this.form3.recommendBar2.note = '推荐栏2'
      }
      if (!this.form3.recommendBar2.link) {
        this.form3.recommendBar2.link = 'https://www.xiaoi.com'
      }
    },
    // 推荐栏3图片上传成功后的处理
    handleRecommendPic3Success(res, file) {
      this.recommendBar3Url = URL.createObjectURL(file.raw)
      this.form3.recommendBar3.url = res.url
      if (!this.form3.recommendBar3.note) {
        this.form3.recommendBar3.note = '推荐栏3'
      }
      if (!this.form3.recommendBar3.link) {
        this.form3.recommendBar3.link = 'https://www.xiaoi.com'
      }
    },
    // 【推荐栏配置】图片上传前校验
    beforeUpload2(file) {
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 1MB!')
      }
      return isLt2M
    },
    setCommonQANum(size) {
      this.form3.commonQANum = size
    },
    insertMutil(newCachePlatformAcdId) {
      if (!this.cachePlatformAcdId && this.tempCommonQAList.length > 0) {
        this.tempCommonQAList.forEach(qr => { qr.channelId = newCachePlatformAcdId })
        insertMutil(this.tempCommonQAList).then(res => {
          if (res.code !== 2000) {
            this.$message.error(res.msg)
          } else {
            this.tempCommonQAList = []
          }
        }).catch(err => {
          this.$message.error(err)
        })
      } else if (this.cachePlatformAcdId && this.cachePlatformAcdId !== newCachePlatformAcdId && this.form3.commonQANum > 0) {
        updateChannelId(this.cachePlatformAcdId, newCachePlatformAcdId).then(res => {
          if (res.code !== 2000) {
            this.$message.error(res.msg)
          } else {
            this.tempCommonQAList = []
          }
        }).catch(err => {
          this.$message.error(err)
        })
      }
    }
  }
}
</script>
<style lang="scss">
.text-left {
  .el-upload {
    text-align: left;
  }
  .el-form-item__content {
    // line-height: 30px;
  }
}
</style>
<style lang="scss" scoped>
.wrapper {
  height: 100%;
}
.main-content {
  height: calc(100% - 80px);
}
.scrollbar-wrap {
  height: calc(100% - 100px);
}
.webhfive-addbox-title {
  background-color: #f5f5f5;
  height: 38px;
  line-height: 38px;
  font-size: 16px;
  margin-bottom: 10px;
  text-align: left;
  i {
    width: 3px;
    height: 14px;
    border-radius: 1px;
    display: inline-block;
    background-color: #337eff;
    margin: 13px 17px 0 0;
  }
}
.system-stepbtn {
  margin-top: 20px;
}
.radio-border {
  ::v-deep &:after {
    content: "";
    display: block;
    border: 1px solid #fff;
    border-left: 0;
    border-top: 0;
    height: 16px;
    left: 4px;
    position: absolute;
    top: 1px;
    transform: rotate(45deg) scaleY(0);
    width: 16px;
  }
  ::v-deep .el-radio {
    &.is-bordered {
      margin-right: 8px;
      border-color: transparent;
      line-height: 0.8;
      border-radius: 0;
      padding: 2px;
      height: auto;
      & + .is-bordered {
        margin-left: 0;
      }
      .el-radio__label {
        padding-left: 0;
      }
      .el-radio__inner {
        background-color: transparent;
        border-color: transparent;
      }
    }
    &.is-checked {
      border-color: #337eff;

      .el-radio__inner {
        background-color: #337eff;
        &:after {
          content: "";
          position: absolute;
          top: 3px;
          left: 5px;
          width: 5px;
          height: 9px;
          border-radius: 0;
          background-color: transparent;
          border-color: #fff;
          border-style: solid;
          border-width: 0 1px 2px 0;
          transform: rotate(45deg);
        }
      }
    }
  }
  ::v-deep .el-radio__input {
    /*display: none;*/
    position: absolute;
    top: -6px;
    right: -6px;
    width: 16px;
    height: 16px;
    border-radius: 50%;
  }
  &.is-checked {
    position: relative;
    ::v-deep &:after {
      background-color: #337eff;
      transform: rotate(45deg) scaleY(1);
    }
  }
}

.el-form {
  .el-form-item {
    margin-bottom: 10px;
    ::v-deep .el-form-item__content {
      .el-upload {
        margin-top: 3px;
        .el-button {
          padding: 0;
          border: 1px solid transparent;
          background-color: transparent;
          color: #337eff;
          > * {
            display: flex;
            align-items: center;

            .icon {
              font-size: 34px;
              color: #99a3ae;
            }
          }
        }
      }
      .el-upload__tip {
        margin-top: -15px;
        margin-bottom: 5px;
        color: #999;
        line-height: 1.4;
        padding-top: 10px;
      }
    }
  }
  .el-button {
    & + .el-button {
      margin-left: 10px;
    }
  }
}
.avatarImgCls {
  width: 100px;
  height: 100px;
  display: block;
}
.avatarImgCls2 {
  width: 300px;
  height: 140px;
  display: block;
  object-fit: contain;
}
</style>
